"use client";

import ActiveAnchor from "@/components/common/ActiveAnchor";
import List from "@/components/common/List";
import { useTranslation } from "@/i18n/client";
import { type LanguageSelectorProps } from "../index";
import s from "./ButtonSelector.module.css";

export default function ButtonSelector(
  props: Pick<LanguageSelectorProps, "list">,
) {
  const { list } = props;
  const { t } = useTranslation();

  return (
    <List
      items={list}
      renderItem={(localeItem) => (
        <ActiveAnchor href={localeItem.path} extendedURI={false}>
          {t(`languages.${localeItem.locale.toUpperCase()}.label`)}
        </ActiveAnchor>
      )}
      className={s.list}
    />
  );
}
